<template>
  <div class="bg-white p-2 border">
    <UserProfileGroupedFilter :filters="filters">
      <template #default>
        <h2 class="h5">
          {{ i18n('Profiles') }}
        </h2>
      </template>

      <template #buttons>
        <UserProfileCreateAction v-if="can('USER_MANAGE') || can('RESPONSIBLE_USER_MANAGE')" :user="user" @created="load()" />
      </template>
    </UserProfileGroupedFilter>

    <UserProfileGroupedList :user="user" :applicationProfiles="applicationProfiles" :loading="loading"
      :autoLazyLoad="!!pagination.nextPageURI" @deleted="reload" @updating="loading = true" @updated="reload"
      @next="nextPage" @goToPage="goToPage" />
  </div>
</template>

<script>
import paginatedViewMixin from "@/mixins/common/paginatedViewMixin.js";
import UserProfileGroupedFilter from "@/components/userProfile/UserProfileGroupedFilter.vue";
import UserProfileCreateAction from "@/components/userProfile/UserProfileCreateAction.vue";
import UserProfileGroupedList from "@/components/userProfile/UserProfileGroupedList.vue";

export default {
  mixins: [paginatedViewMixin,],
  components: {
    UserProfileCreateAction,
    UserProfileGroupedFilter,
    UserProfileGroupedList,
  },
  emits: ['updated'],
  props: {
    user: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      listPropertyName: 'applicationProfiles',
      apiResource: `users/${this.user.id}/profiles/groupedByApp`,
      applicationProfiles: [],
    }
  },
  created() {
    this.pagination.limit = 1000;
  },
  mounted() {
    this.load();
  },
  watch: {},
  methods: {},
};
</script>
